export const dnldRuMapping = (builder) => ({
    dnldRuMapping: builder.mutation({
      query: ({ search, login_user_id, loggedin_user_id, user_type_id, user_type }) => {
        return {
          url: '/download_list_of_enteprise_user_acc_reporting_user',
          method: 'GET',
          params: { search, login_user_id, loggedin_user_id, user_type_id, user_type },
          headers: {
            'Content-Type': 'text/csv',
          },
          responseHandler: (response)=>response.blob(),
        };
      },
    }),
  });
  